<template>
    <div>
        <div class="main">
            <div class="box" v-show="!showresult">
                <div class="box1">
                    <div class="box2">优惠政策匹配，一键获取最新专属优惠政策
                        <icon custom="i-icon" size="24" />
                    </div>
                    <div class="box3">
                        <div class="box31">
                            <div class="box311">
                                <img src="../../../assets/images/taxmatch/yhzc_diannao.png" />
                            </div>
                            <div class="box312">
                                <Form ref="formCustom" v-if="isshow" class="form" :model="formCustom" :rules="ruleCustom" :label-width="120">
                                    <FormItem label="公司名称" prop="unitname">
                                        <Input type="text" v-model="formCustom.unitname" placeholder="请填写公司名称"></Input>
                                    </FormItem>
                                    <FormItem label="所在地域" prop="locationcode">
                                        <Cascader v-model="formCustom.locationcode" :data="citys" change-on-select :placeholder="holdertext" @on-change="onChange"></Cascader>
                                    </FormItem>
                                    <FormItem label="所属行业" prop="industrycode">
                                        <Select v-model="formCustom.industrycode" placeholder="请选择所属行业" @on-select="industry_item_selected" clearable transfer style="text-align: left;">
                                            <Option v-for="item in industryData" :value="item.industryid" :key="item.industryid">{{ item.title }}</Option>
                                        </Select>
                                    </FormItem>
                                    <FormItem label="所属项目" prop="itemcode">
                                        <Select v-model="formCustom.itemcode" placeholder="请选择所属项目" @on-select="tax_item_selected" clearable transfer style="text-align: left;">
                                            <Option v-for="item in items_incentives" :value="item.id" :key="item.id">{{ item.label }}</Option>
                                        </Select>
                                    </FormItem>
                                    <FormItem label="联系电话" prop="unittel">
                                        <Input type="text" v-model="formCustom.unittel" placeholder="请填写联系电话"></Input>
                                    </FormItem>
                                </Form>
                            </div>
                            <div class="box313"><Icon type="md-pin" size=15 :color="iconColor" :style="{display:autoLocate?'inline-block':'none'}" /></div>
                        </div>
                        <div class="box32">
                            <div class="box321">
                            </div>
                            <div class="box322">
                                <div class="box3211">
                                    <img src="../../../assets/images/taxmatch/qiye1.png" />
                                </div>
                                <div class="box3211"><img src="../../../assets/images/taxmatch/qiye2.png" /></div>
                                <div class="box3211"></div>
                                <div class="box3211"></div>
                            </div>
                            <div class="box323">
                                <div class="box3212"><img src="../../../assets/images/taxmatch/qiye3.png" /></div>
                                <div class="box3213"><img src="../../../assets/images/taxmatch/qiye4.png" /></div>
                                <div class="box3215"><img src="../../../assets/images/taxmatch/qiye5.png" /></div>
                                <div class="box3212"><img src="../../../assets/images/taxmatch/qiye6.png" /></div>
                                <div class="box3214"><img src="../../../assets/images/taxmatch/qiye7.png" /></div>
                            </div>
                            <div class="box321">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-end">
                    <Button type="warning" class="matchbtn" @click="commit">{{btntxt}}</Button>
                </div>
                <div class="box-end-loadding" v-show="isShowLoadingBar">
                    <Progress style="width:340px;margin-left: 50px;" :percent="matchprogress">
                    </Progress>
                </div>
            </div>
            <div class="result" v-show="showresult">
                <itable :key="rid" ref="resultList1" @update-progress="addprogress" @rematch="re_match" />
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import IncentiveTable from './tax_incentives_result.vue'
import ConstJson from '../../../api/common/constjson.js'
import store from '../../../store'
import eventBus from "../../../components/common/event_bus.js"
let constJ = new ConstJson()
export default {
    name: 'tax_incentive',
    inject: ["setFileMatchIndex"],
    data() {
        //校验单位名称
        const validateUnitName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入公司名称'));
            } else {
                callback();
            }
        }
        //校验联系电话
        const validateUnitTel = (rule, value, callback) => {
            if (value === '') {
            	callback()
                //callback(new Error('请输入联系电话'));
            } else {
                if (this.checkPhone(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确的手机号码.'));
                }
            }
        }
        //校验所属行业信息
        const validateIndustryCode = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请选择所属行业'));
            } else {
                callback();
            }
        }
        //校验所属项目信息
        const validateitemsCode = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请选择所属项目'));
            } else {
                callback();
            }
        }
        //校验所属地域信息
        const validateLocationCode = (rule, value, callback) => {
            if (!value || value.length === 0) {
                callback(new Error('请选择所属地域'));
            } else {
                callback();
            }
        }

        return {
            rid: +new Date(),
            btntxt: "立即匹配",
            isShowLoadingBar: false,
            matchprogress: 0,
            showresult: false,
            isshow: false,
            user: store.state.user,
            citys: [], // this.getProvinceCity(),
            industryData: [], // this.getIndustryData(),
            items_incentives: [], //this.getItems(),
            holdertext: '请选择所在地域',
            formCustom: {
                unitname: '',
                unittel: '',//store.state.user.mobileNum,
                industrycode: '',
                itemcode: '',
                locationcode: [],
                tax_selected_item: {},
                industr_selected_item: {},
                location_item:[]
            },
            ruleCustom: {
                unitname: [{ required: true, validator: validateUnitName, trigger: 'blur' }],
                unittel: [{ required: false, validator: validateUnitTel, trigger: 'blur' }],
                industrycode: [{ required: true, validator: validateIndustryCode, trigger: 'blur' }],
                itemcode: [{ required: true, validator: validateitemsCode, trigger: 'blur' }],
                locationcode: [{ required: true, validator: validateLocationCode, trigger: 'blur' }],
                // agreement: [
                //   { required: true, type:'boolean',validator: validateAgreement, trigger: 'change' }
                // ],
            },
            locateDesc: '',
            show: false,
            value: [{ label: "　", value: "" }, { label: "　", value: "" }],
            value2: [{ label: "　", value: "" }, { label: "　", value: "" }],
            iconColor:'#fff',
            autoLocate:false,

        }
    },
    created: function() {
        console.log('loading tax_incentives===>')
        // setInterval(()=>{
        // 	console.log(this.industryData.length)
        // },500)
        let that = this
        let timer = setInterval(() => {
            console.log('di--------')
            if (that.getIndustryData().length > 0) {
                window.clearInterval(timer)

                this.citys = this.getProvinceCity()
                this.industryData = this.getIndustryData()
                this.industryData.shift() //移除第一项（所有行业）
                this.items_incentives = this.getItems()
                this.setFileMatchIndex()
                this.$nextTick(() => {
                    this.isshow = true
                    this.autoLocation()
                })
            }
        }, 200)

    },
    components: {
        'itable': IncentiveTable,
    },
    computed: {
        ...mapGetters(['getAccountType', 'getUserId'])
    },
    watch: {
        getAccountType: function(v) {
            console.log('watch getAccountType===>')
            if (v !== 0 && this.showresult) {
                this.$refs.resultList1.showResult(this.formCustom)
            }else if(v !==0 &&!this.showresult){
            	// let _mb=store.state.user.mobileNum
            	// let mobile= _mb.replace(_mb.substring(3,7),'****')
            	// this.formCustom.unittel=mobile
            }

        }
    },
    mounted() {
        this.$nextTick(()=>{
            //this.initStep()
        })
    },
    methods: {
        ...mapActions([
            'handleTempUserLogin',
        ]),
        re_match() {
            this.reset()
            // window.location.reload()
        },

        initStep() {
            this.$intro().setOptions({
            prevLabel:"返回",
            nextLabel:"下一步",
            doneLabel:"结束",
            overlayOpacity:"0.8",
            steps: [{
                intro: '欢迎使用优惠政策引导'
              },
              {
                element: document.querySelector('.box312'),
                intro: '一键获取所在企业税收优惠政策',
                position: 'right'
              },
              {
                element: document.querySelector('.box311'),
                intro: '优惠政策应享尽享',
                position: 'right'
              },{
                element: document.querySelector('.matchbtn'),
                intro: '立即匹配税收优惠政策',
                position: 'right'
              }]
            }).start();
        },
        reset() {
            this.showresult = false
            this.formCustom.unitname=''
            this.formCustom.unittel=''
            this.formCustom.industrycode = ''
            this.formCustom.itemcode = ''
            this.formCustom.locationcode = []
            this.formCustom.location_item=[]
            this.formCustom.tax_selected_item = {}
            this.formCustom.industr_selected_item = {}
            this.btntxt = "立即匹配"
            this.isShowLoadingBar = false
            this.matchprogress=0
            this.rid = +new Date()
            this.autoLocation()
        },
        tax_item_selected(value) {
            console.log(value)
            this.formCustom.tax_selected_item = value
        },
        industry_item_selected(value) {
            console.log(value)
            this.formCustom.industr_selected_item = value
        },
        commit() {

            this.$refs['formCustom'].validate((valid) => {
                if (valid) {
                    console.log(this.formCustom)
                    this.$refs.resultList1.showResult(this.formCustom)
                    this.isShowLoadingBar = true
                    this.btntxt = "匹配中..."
                    // if (store.state.user.accounttype !== 0) {
                    //     this.$refs.resultList1.showResult(this.formCustom)
                    //     this.isShowLoadingBar=true
                    //     this.btntxt="匹配中..."
                    // } else {
                    //     console.log('未登录==>')
                    // }
                }
            })
        },
        checkPhone(phoneNum) {
            var phone = phoneNum;
            if (!(/^1[3|4|5|6|7|8|9]\d{9}$/.test(phone))) {
                //alert("手机号码有误，请重填");  
                return false;
            } else {
                return true;
            }
        },
        addprogress() {
            this.matchprogress += 34
            if (this.matchprogress >= 100) {
                this.matchprogress = 100
                this.btntxt = "匹配完成"
                setTimeout(() => {
                    this.showresult = true
                }, 1000)
            }
            console.log("this.matchprogress:" + this.matchprogress)
        },
        tempUserLogin() {
            console.log('优惠匹配临时登录==>')
            this.handleTempUserLogin()
                .then(res => {
                    console.log(res)
                    this.citys = this.getProvinceCity()
                    this.industryData = this.getIndustryData()
                    this.items_incentives = this.getItems()
                    this.$nextTick(() => {
                        this.isshow = true
                    })
                    this.setFileMatchIndex()
                }).catch(err => {
                    console.log(err)
                })
        },
        getProvinceCity() {
            let res = store.state.user.initData.provinceCity
            console.log('getProvinceCity====>')
            console.log(res)
            return res
        },
        getIndustryData() {
            let res = store.state.user.initData.offersIndustry
            return res
        },
        getItems() {
            let res = store.state.user.initData.reduction
            return res
        },
        onChange(val, data) {
            console.log(data)
            this.formCustom.location_item = data
            this.autoLocate = false
        },
        autoLocation() {
            constJ.ReqGetLocation().then(res => {
                console.log(res)
                if (res.rltcode === 1) {
                    if (res.rtncode === 1) {
                        this.value = []
                        this.value.push(res.postion.provice)
                        this.value.push(res.postion.city)

                        this.value2 = []
                        var p = {
                            label: res.postion.provicelabel,
                            value: res.postion.provice
                        }
                        var c = {
                            label: res.postion.citylabel,
                            value: res.postion.city
                        }
                        this.value2.push(p)
                        this.value2.push(c)
                        this.autoLocate = true
                    } else {
                        this.locateDesc = res.rtncode
                        //this.showErrorLocate=true
                    }
                } else {
                    if (res.rltcode === -1) {
                        this.autoLocate = false
                        //this.showErrorLocate = true
                        this.value2 = []
                        var p = {
                            label: res.postion.provicelabel,
                            value: res.postion.provice
                        }
                        this.value2.push(p)
                        //this.$emit('autoLocation',this.value2)//触发右侧列表显示
                    } else {
                        //-9998
                        this.locateDesc = res.rltdesc
                        //this.showErrorLocate = true
                    }
                }
                console.log(this.value)
                console.log(this.value2)
                let auto_location=[]
                this.value2.forEach(item=>{
                	auto_location.push(item.value)
                })
                this.formCustom.locationcode=auto_location
                this.formCustom.location_item=this.value2
                console.log(this.formCustom.locationcode)
                this.show = false
            }).catch(err => {
                this.locateDesc = "定位失败,请手动选择"
                setTimeout(() => {
                    this.value2 = this.value
                    this.value = Array.from(this.value, (x) => x.value)
                    this.show = false
                }, 1000 * 2)
                console.log(err)
            })
        }
    },
}
</script>
<style lang="less" scoped>
.main {
    display: flex;
    min-height: 100vh;
    flex-direction: column; //纵向排列
    padding: 10px;
    background-color: #F7F9FA;

    .box {
        height: 100vh;
        background-color: white;
        padding: 10px;

        .box-end {
            //background-color: white;
            display: flex;
            height: 110px;
            justify-content: center;
            align-items: center;

            .matchbtn {
                width: 280px;
                height: 40px;
                background: #FF6002;
                border-radius: 2px;
                box-shadow: none;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
            }

            .matchbtn:hover {
                background: #ff9900;
            }
        }

        .box-end-loadding {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 10px;
        }

        .box1 {
            display: flex;
            height: 630px;
            background: linear-gradient(0deg, #F7662A 0%, #F99744 100%);
            flex-direction: column; //纵向排列

            .box2 {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 130px;
                font-size: 32px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;

            }

            .box3 {
                display: flex;
                height: 510px;
                flex-direction: column; //纵向排列

                .box31 {
                    display: flex;
                    height: 313px;
                    flex-direction: row; //纵向排列

                    //background:red;
                    .box311 {
                        display: flex;
                        justify-content: right;
                        align-items: center;
                        width: 50%;
                        margin-bottom: 20px;
                        //background:red;
                    }

                    .box312 {
                        display: flex;
                        justify-content: left;
                        align-items: center;
                        position: relative;
                        //background:blue;
                        /deep/.ivu-form-item-label {
                            font-size: 16px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            color: #fff;
                            width: 100px;
                        }

                        /deep/.ivu-form-item {
                            margin-bottom: 24px;
                            min-width: 400px;
                        }

                        /deep/.ivu-form-item-error-tip {
                            color: yellow;
                        }

                    }
                    .box313 {
                    	display: flex;
                        justify-content: left;
                        align-items: flex-start;
                        margin-top: 75px;
                        margin-left:10px;

                    }
                }

                .box32 {
                    display: flex;
                    height: 187px;
                    //background:yellow;
                    flex-direction: row; //纵向排列

                    .box321 {
                        display: flex;
                        //background:red;
                        flex: 4;


                    }

                    .box322 {
                        display: flex;
                        //background:red;
                        flex: 4;
                        min-width: 400px;

                        .box3211 {
                            display: flex;
                            flex: 4;
                            justify-content: center;
                            align-items: flex-end;
                        }

                        .box3212 {
                            display: flex;
                            flex: 5;
                            justify-content: center;
                            align-items: flex-end;
                        }
                    }

                    .box323 {
                        display: flex;
                        //background:red;
                        flex: 4;
                        min-width: 400px;

                        .box3212 {
                            display: flex;
                            flex: 5;
                            justify-content: center;
                            align-items: flex-end;
                        }

                        .box3213 {
                            display: flex;
                            flex: 5;
                            justify-content: right;
                            align-items: flex-start;
                        }

                        .box3214 {
                            display: flex;
                            flex: 5;
                            justify-content: left;
                            align-items: flex-start;
                        }

                        .box3215 {
                            display: flex;
                            flex: 5;
                            justify-content: right;
                            align-items: flex-end;
                            margin-bottom: 10px;
                        }
                    }
                }
            }
        }

        //box1
    }
}
</style>